
namespace RecordShield.Workspace {
    
    @Serenity.Decorators.registerClass()
    export class ProductItems2Grid extends Serenity.EntityGrid<ProductItems2Row, any> {
        protected getColumnsKey() { return 'Workspace.ProductItems2'; }
        protected getDialogType() { return ProductItems2Dialog; }
        protected getIdProperty() { return ProductItems2Row.idProperty; }
        protected getLocalTextPrefix() { return ProductItems2Row.localTextPrefix; }
        protected getService() { return ProductItems2Service.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;
        constructor(container: JQuery) {
            super(container);
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getSlickOptions(): Slick.GridOptions {
            var opt: Slick.GridOptions = super.getSlickOptions();
            opt.enableTextSelectionOnCells = true;
            opt.selectedCellCssClass = "slickgrid-row-selected";
            opt.enableCellNavigation = true;
            return opt;
        }

        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(RecordShield.Common.ExcelExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                service: 'Workspace/ProductItems2/ListExcel',
                separator: true
            }));
            buttons.push(RecordShield.Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit()
            }));

            buttons.push({
                title: 'Delete Product Items',
                cssClass: 'send-button',
                onClick: () => {
                    var rowKeys = this.rowSelection.getSelectedKeys();
                    var count = rowKeys.length;
                    if (rowKeys.length == 0) {
                        // *** User has not selected any queue. Therefore nothing is to be done ***
                        Q.alert("Please select Record for delete!");
                        return;
                    }
                           
                    Q.confirm('Are you sure you want to delete?', () => {
                        var entity;
                        for (var i = 0; i < rowKeys.length; i++) {
                            RecordShield.Workspace.ProductItems2Service.Retrieve({
                                EntityId: rowKeys[i]
                            }, response => {
                                entity = response.Entity;
                                Q.serviceRequest('Workspace/ProductItems2/UpdateStaus', {
                                    EntityId: rowKeys[i],
                                    Entity: entity
                                }, (response) => {
                                        if (i == rowKeys.length) {
                                            window.location.reload();
                                        }
                                });
                            });
                            //if (i == rowKeys.length)
                            //{
                            //    window.location.reload();
                            //}
                        }
                        this.rowSelection.resetCheckedAndRefresh();
                        this.refresh();
                        
                        
                    });      
                        
                    
                }
            });
            return buttons;
        }
    }
}